import numeral from "numeral";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { MONTHS } from "../../constants";
import { anggaran, aruskas } from "../../utils/financeFormula";
import { dateIndo } from "../../utils/helper";

const DetailArusKas = () => {
  const location = useLocation();
  const history = useHistory();
  const d = localStorage.getItem(location.pathname);
  const data = d ? JSON.parse(d) : null;
  if (data === null) history.push("/approval");

  const parseStatus = (s) => {
    const status = [
      {},
      { className: "badge badge-warning", text: "Pending" },
      { className: "badge badge-success", text: "Approved" },
      { className: "badge badge-danger", text: "Rejected" },
    ];
    return <span className={status[s].className}>{status[s].text}</span>;
  };

  const tables1 = [
    { label: "Created By", value: data?.createdBy?.name ?? "-", type: "text" },
    { label: "Created At", value: data?.createdAt ? dateIndo(data?.createdAt) : "-", type: "text" },
    { label: "Updated By", value: data?.updatedBy?.name ?? "-", type: "text" },
    { label: "Updated At", value: data?.updatedAt ? dateIndo(data?.updatedAt) : "-", type: "text" },
    { label: "Approved By", value: data?.approvedBy?.name ?? "-", type: "text" },
    { label: "Approved At", value: data?.approvedAt ? dateIndo(data?.approvedAt) : "-", type: "text" },
    { label: "Rejected By", value: data?.rejectedBy?.name ?? "-", type: "text" },
    { label: "Rejected At", value: data?.rejectedAt ? dateIndo(data?.rejectedAt) : "-", type: "text" },
    { label: "Status", value: parseStatus(data.status) },
  ];

  const tables2 = [
    { label: "Penerimaan Dari Pelanggan", value: data.penerimaanDariPelanggan, type: "numeral" },
    { label: "Penerimaan Lain-lain", value: data.penerimaanLain, type: "numeral" },
    { label: "Pengeluaran Beban Operasional", value: data.pengeluaranOperasional, type: "numeral" },
    { label: "Pengeluaran Lain-lain", value: data.pengeluaranLain, type: "numeral" },
    { label: <b>Kas Bersih Dari Aktifitas Operasional</b>, value: aruskas.kasOperasional(data), type: "numeral" },
    { label: "Pengeluaran untuk Pembelian Aset", value: data.pengeluaranUntukPembelianAset, type: "numeral" },
    { label: "Pengeluaran Investasi Lainnya", value: data.pengeluaranInvestasiLain, type: "numeral" },
    { label: <b>Kas Bersih Dari Aktifitas Investasi</b>, value: aruskas.kasInvestasi(data), type: "numeral" },
    { label: "Penerimaan Dari Pinjaman", value: data.penerimaanDariPinjaman, type: "numeral" },
    { label: "Penerimaan Dari Modal Disetor", value: data.penerimaanDariModalDisetor, type: "numeral" },
    { label: "Pengeluaran untuk Pokok Pinjaman", value: data.pengeluaranUntukPokokPinjaman, type: "numeral" },
    { label: "Pengeluaran untuk Pembiayaan Lainnya", value: data.pengeluaranPembiayaanLain, type: "numeral" },
    { label: <b>Arus Kas dari Aktifitas Pendanaan</b>, value: aruskas.kasPendanaan(data), type: "numeral" },
    { label: "Kas atau Setara Kas di Awal Periode", value: data.kasAwal, type: "numeral" },
    { label: <b>Kenaikan/Penurunan Kas atau Setara Kas</b>, value: aruskas.kasPerubahan(data), type: "numeral" },
    { label: <b>Kas atau Setara Kas di Akhir Periode</b>, value: aruskas.kasAkhir(data), type: "numeral" },
    { label: "Catatan", value: data?.notes ?? "-", type: "text" },
  ];

  
  const tables3 = [
    { label: " ARUS KAS DARI AKTIVITAS OPERASI ",value: data.arusAktivitasOperasi,type: "numeral" },
    { label: " ARUS KAS DARI AKTIVITAS INVESTASI ",value: data.arusAktivitasInvestasi,type: "numeral" },
    { label: " ARUS KAS DARI AKTIVITAS PENDANAAN ",value: data.arusAktivitasPendanaan,type: "numeral" },
    { label: <b>Kenaikan/Penurunan Kas atau Setara Kas</b>, value: aruskas.KenaikanKasSetaraKas(data), type: "numeral" },
    { label: <b>Kas atau Setara Kas di Awal Periode</b>, value: aruskas.kasAwalPeriode(data), type: "numeral" },
    { label: <b>Kas atau Setara Kas di Akhir Periode</b>, value: aruskas.kasAkhirPeriode(data), type: "numeral" },
   
  ];

  return (
    <>
      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mr-auto my-auto">
                Detail Arus Kas - {MONTHS[data.month * 1 - 1]} {data.year}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <div className="card container shadow-sm border-0 p-3">
          <div className="row">
            <div className="col-6">
              <table className="table table-striped">
                <tbody>
                  {tables3.map((table, i) => (
                    <tr key={i}>
                      <td width={300}>{table.label}</td>
                      <td>:&ensp; {table.type === "numeral" ? `Rp. ${numeral(table.value).format(0, 0)}` : table.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-6">
              <table className="table table-striped">
                <tbody>
                  {tables1.map((table, i) => (
                    <tr key={i}>
                      <td width={150}>{table.label}</td>
                      <td>:&ensp; {table.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-secondary" onClick={() => window.history.back()}>
                Kembali
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailArusKas;
